<template>
    <section class="reports-panel">
        <header class="panel-header">
            <button
                v-if="showMenu"
                type="button"
                class="menu-btn"
                aria-label="Открыть меню"
                @click="$emit('toggle-sidebar')"
            >
                <ChatIcon name="list" :size="18" />
            </button>

            <span class="title-icon">
                <ChatIcon name="database" :size="14" />
            </span>
            <div class="title-text">
                <div class="title">Доступные данные (Excel/CSV)</div>
                <div class="subtitle">
                    Готовые таблицы по вашему тарифу — посмотрите данные и скачайте в Excel или CSV.
                </div>
            </div>
        </header>

        <nav class="tabs" role="tablist">
            <button
                v-for="tab in tabs"
                :key="tab.id"
                type="button"
                class="tab"
                :class="{ 'tab--active': activeTab === tab.id, 'tab--disabled': tab.disabled }"
                :disabled="tab.disabled"
                role="tab"
                :aria-selected="activeTab === tab.id"
                @click="!tab.disabled && (activeTab = tab.id)"
            >
                <span>{{ tab.label }}</span>
                <span v-if="tab.disabled" class="tab-badge">скоро</span>
            </button>
        </nav>

        <div class="panel-body">
            <section v-show="activeTab === 'catalog'" class="tab-panel">
                <ReportsCatalog @upgrade="$emit('upgrade')" />
            </section>

            <section v-show="activeTab === 'builder'" class="tab-panel tab-panel--center">
                <div class="placeholder">
                    <span class="placeholder-icon">
                        <ChatIcon name="database-search" :size="26" />
                    </span>
                    <p class="placeholder-title">Конструктор отчётов скоро появится</p>
                    <p class="placeholder-text">
                        Здесь можно будет собирать свои таблицы: выбирать показатели, периоды и фильтры.
                    </p>
                </div>
            </section>
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue'
import ChatIcon from '@/components/chat/icons/ChatIcon.vue'
import ReportsCatalog from './ReportsCatalog.vue'

defineProps({
    showMenu: { type: Boolean, default: false },
})

defineEmits(['toggle-sidebar', 'upgrade'])

const tabs = [
    { id: 'catalog', label: 'Готовые таблицы', disabled: false },
    { id: 'builder', label: 'Конструктор отчётов', disabled: true },
]

const activeTab = ref('catalog')
</script>

<style scoped>
.reports-panel {
    flex: 1;
    min-width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: white;
    min-height: 0;
}

.panel-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 20px;
    background: white;
    border-bottom: 1px solid #e7e7e7;
    min-height: 44px;
    flex-shrink: 0;
}

.menu-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    border: 1px solid #e0e0e0;
    background: white;
    color: #23282C;
    cursor: pointer;
}

.menu-btn:hover {
    background: #f7f7f7;
}

.title-icon {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: #e7e7e7;
    color: #23282C;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.title-text {
    min-width: 0;
    flex: 1;
}

.title {
    font-size: 14px;
    font-weight: 600;
    color: #23282C;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.subtitle {
    font-size: 11px;
    color: #888888;
    margin-top: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tabs {
    display: flex;
    gap: 4px;
    padding: 0 20px;
    border-bottom: 1px solid #e7e7e7;
    background: white;
    flex-shrink: 0;
}

.tab {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 4px;
    margin-right: 12px;
    border: 0;
    background: transparent;
    font-family: inherit;
    font-size: 13px;
    font-weight: 600;
    color: #5f5f5f;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
}

.tab--active {
    color: #198FA0;
    border-bottom-color: #198FA0;
}

.tab--disabled {
    color: #B4B2A9;
    cursor: not-allowed;
}

.tab-badge {
    font-size: 9.5px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #888888;
    background: #e7e7e7;
    padding: 2px 6px;
    border-radius: 8px;
}

.panel-body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    background: #f4f5f6;
    padding: 16px;
}

.tab-panel {
    flex: 1;
    min-height: 0;
    width: 100%;
    max-width: 1320px;
    margin: 0 auto;
    display: flex;
    min-width: 0;
}

.tab-panel--center {
    align-items: center;
    justify-content: center;
}

.placeholder {
    padding: 48px 28px;
    text-align: center;
    color: #888888;
    background: #fff;
    border: 1px dashed #dcdcdc;
    border-radius: 12px;
    max-width: 420px;
}

.placeholder-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 14px;
    background: #eef4f5;
    color: #198FA0;
    margin-bottom: 6px;
}

.placeholder-title {
    margin: 12px 0 4px;
    font-size: 15px;
    font-weight: 600;
    color: #23282C;
}

.placeholder-text {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
}
</style>
